import { Router } from '@angular/router';
import { LocalStorageService } from './../../local-storage.service';
import { AlertController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-continue',
  templateUrl: './continue.component.html',
  styleUrls: ['./continue.component.scss'],
})
export class ContinueComponent implements OnInit {

  constructor(
    private alertCtrl: AlertController,
    private localStorageService: LocalStorageService,
    private router: Router
  ) { }

  ngOnInit() {}

  continue(){
    this.router.navigate(['/questionnaire/result']);
  }

  async startAgain(){
    const alert = this.alertCtrl.create({
      header:'Neu starten',
      message: 'Möchtest Du wirklich neu starten? Deine bisher gespeicherten Eingaben werden dann überschrieben.',
      cssClass: 'alertBox',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
        },
        {
          text: 'Neu starten',
          handler: () => {
            //remove answers
            this.localStorageService.remove('isFinishedCheck');
            this.localStorageService.remove('questionnaire');
            this.router.navigate(['/questionnaire/question']);
          }
        }
      ]
    }).then(res => {
      res.present();
    });
}

}
